import React, {useRef, useState} from 'react';
import {useHistory} from "react-router-dom";
import {Button, Row, UncontrolledAlert} from "reactstrap";
import loginImage from 'assets/img/login.png'
import './css/login.css'
import {loginApi} from 'module/services/services';
import {setAuth} from "../utils/store/Accounting/AccountingActions";

const Login = (props) => {
    const [error, setError] = useState(null);
    const history = useHistory();
    const usernameRef = useRef();
    const passwordRef = useRef();

    const handleLogin = async () => {
        setError(null)

        const loginData = {
            username: usernameRef.current.value,
            password: passwordRef.current.value
        }

        const response = await loginApi(loginData);
        if (response.success) {
            localStorage.setItem('fullName', response.data.fullName);
            localStorage.setItem('role', response.data.role);
            setAuth(true)
            localStorage.setItem('accessToken', response.data.token);
            history.push('/admin/dashboard')
        } else {
            setError(response.errorMessage);
        }

    }

    return (
        <div className="content bg-login">
            <div className="container">
                <div className={"loginrow"}>
                    <div className="ml-auto mr-auto col-md-6 col-lg-4">
                        <form className="form">
                            <div className="card-login card-white card">
                                <div className="card-header"><img alt="..." src={loginImage}/>
                                    <h3 className="card-title login-title">ورود به داشبورد</h3></div>
                                <div className="card-body">
                                    <div>
                                        {error != null ? (
                                            <UncontrolledAlert color="danger">{error}</UncontrolledAlert>
                                        ) : null}
                                    </div>
                                    <div className="input-group">
                                        <div className="input-group-prepend"><span className="input-group-text"><i
                                            className="tim-icons icon-single-02"></i></span></div>
                                        <input ref={usernameRef} placeholder="تلفن همراه" type="text"
                                               className="form-control"/></div>
                                    <div className="input-group">
                                        <div className="input-group-prepend"><span className="input-group-text"><i
                                            className="tim-icons icon-lock-circle"></i></span></div>
                                        <input ref={passwordRef} placeholder="گدروازه" type="password"
                                               className="form-control"/></div>
                                </div>
                                <div className="card-footer">
                                    <Button className="mb-3 btn btn-info btn-lg btn-block"
                                            onClick={handleLogin}>ورود</Button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>);
}

export default Login;

